/**
 * Maps each allowed `WidgetIconName` (the schema's Lucide-only icon enum) to its
 * `lucide-react` component. The `Record<WidgetIconName, LucideIcon>` type forces
 * this map to stay in lock-step with `WIDGET_ICON_NAMES` in
 * `shared/widget-schemas.ts` — add a name there and the compiler requires it here.
 *
 * Chat-thread widgets render **Lucide icons only** (never emoji); a widget's
 * `icon` prop is one of these names, resolved via `resolveWidgetIcon`.
 */
import {
  Target,
  Flag,
  Rocket,
  Lightbulb,
  Zap,
  TrendingUp,
  TrendingDown,
  Clock,
  LoaderCircle,
  Gavel,
  Compass,
  Sparkles,
  Star,
  Trophy,
  Search,
  Users,
  Mic,
  FileText,
  ListChecks,
  Activity,
  Calendar,
  GitBranch,
  LayoutGrid,
  Building2,
  ArrowUpRight,
  CircleCheck,
  CircleAlert,
  type LucideIcon,
} from 'lucide-react';

import type { WidgetIconName } from '@shared/widget-schemas';

export const WIDGET_ICONS: Record<WidgetIconName, LucideIcon> = {
  Target,
  Flag,
  Rocket,
  Lightbulb,
  Zap,
  TrendingUp,
  TrendingDown,
  Clock,
  LoaderCircle,
  Gavel,
  Compass,
  Sparkles,
  Star,
  Trophy,
  Search,
  Users,
  Mic,
  FileText,
  ListChecks,
  Activity,
  Calendar,
  GitBranch,
  LayoutGrid,
  Building2,
  ArrowUpRight,
  CircleCheck,
  CircleAlert,
};

/** Resolve an icon name to its Lucide component, falling back when unset/unknown. */
export function resolveWidgetIcon(name: string | undefined, fallback: LucideIcon): LucideIcon {
  if (name && Object.prototype.hasOwnProperty.call(WIDGET_ICONS, name)) {
    return WIDGET_ICONS[name as WidgetIconName];
  }
  return fallback;
}
